import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Helper function to get redirect path based on user role
const getRedirectPathForRole = (role) => {
  switch (role) {
    case 'custom_role_sk':
      return '/branch-order/create-order';
    case 'custom_role_ck':
      return '/central-kitchen/dashboard';
    case 'master_admin':
    case 'admin':
      return '/dashboard';
    default:
      return '/dashboard';
  }
};

const RoleBasedRedirect = ({ children }) => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Only redirect if user is logged in and not already on the correct page
    if (!loading && user && location.pathname === '/dashboard') {
      const redirectPath = getRedirectPathForRole(user.role);
      
      // Only redirect if the user should not be on dashboard
      if (user.role === 'custom_role_sk' || user.role === 'custom_role_ck') {
        console.log('🔄 RoleBasedRedirect: Redirecting user to:', redirectPath);
        navigate(redirectPath, { replace: true });
      }
    }
  }, [user, loading, location.pathname, navigate]);

  return children;
};

export default RoleBasedRedirect;
